import axios, { type AxiosInstance, type AxiosError } from 'axios';
import { getAccessToken } from '@/services/auth.service';

const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use(async (config) => {
  try {
    const token = await getAccessToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch {
    // Falha silenciosa em getAccessToken (sessão inválida) será capturada no response 401
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default apiClient;
